
namespace Matrix.Indexation {
    export class IndexConstituentRorColumns {
        static columnsKey = 'Indexation.IndexConstituentRor';
    }
}